export default __webpack_public_path__ + "e2d7f3f98f6361704605f1ebdac6b023.webp";